import React, { ReactElement } from 'react'

import { ActivateFboInvitation } from '@auth-portal/components'

const ActivateFboInvitationRoute: React.FC<{}> = () =>
  (<ActivateFboInvitation />) as ReactElement

export default ActivateFboInvitationRoute
